import { render, staticRenderFns } from "./ManufacturerProductUpload.vue?vue&type=template&id=72621082&"
import script from "./ManufacturerProductUpload.vue?vue&type=script&lang=js&"
export * from "./ManufacturerProductUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports